import MockReferencesBooks from '../mock-data/MockReferencesBooks.json';
import MockReferencesArticles from '../mock-data/MockReferencesArticles.json';
import MockReferencesSearch from '../mock-data/MockReferencesSearch.json';
import MockReferencesArticlesContent from '../mock-data/MockReferencesArticlesContent.json';
export class TrucodeReferencesService {
    private static instance: TrucodeReferencesService;

    public static getInstance(): TrucodeReferencesService {
        if (!TrucodeReferencesService.instance) {
            TrucodeReferencesService.instance = new TrucodeReferencesService();
        }

        return TrucodeReferencesService.instance;
    }
    public getSearchOptions() : ReferencesBook[] {
        const books : ReferencesBook[] = MockReferencesBooks;
        return books.filter(e => e.searchable)
    }

    public getBrowseOptions() : ReferencesBook[] {
        const books : ReferencesBook[] = MockReferencesBooks;
        return books.filter(e => e.browsable)
    }

    public getReferencesArticles() {
        return MockReferencesArticles;
    }

    public getReferencesSearchResult() {
        return MockReferencesSearch;
    }

    public getReferencesArticleContent(id: string) {
        const content = MockReferencesArticlesContent.filter(e => e.id === id)[0];
        if (content) {
            return content
        }

        return MockReferencesArticlesContent.filter(e => e.id === '227559')[0];
    }
}
export interface ReferencesBook {
    id: string,
    title: string,
    searchable: boolean,
    browsable: boolean
}